/* ==========================================================================
   White Dogs Landingpage — cotonluv.com
   Produktfinder, Größenauswahl, Warenkorb, Sticky-CTA. Keine Abhängigkeiten.
   ========================================================================== */
(function () {
  'use strict';

  function tokens(value) {
    return (value || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
  }

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    } catch (e) { /* Tracking darf die Seite nie blockieren */ }
  }

  /* --- Produktfinder ------------------------------------------------------ */

  function initFinder(root) {
    var cards    = Array.prototype.slice.call(root.querySelectorAll('[data-wd-card]'));
    var chips    = Array.prototype.slice.call(root.querySelectorAll('[data-wd-chip]'));
    var countEl  = root.querySelector('[data-wd-count]');
    var emptyEl  = root.querySelector('[data-wd-empty]');
    var gridEl   = root.querySelector('[data-wd-grid]');
    var resetEl  = root.querySelector('[data-wd-reset]');
    var moreWrap = root.querySelector('[data-wd-more-wrap]');
    var moreBtn  = root.querySelector('[data-wd-more]');

    if (!cards.length || !gridEl) return;

    var STEP    = parseInt(root.dataset.wdStep, 10) || 8;
    var visible = STEP;
    var state   = { age: '', size: '', form: '', flavor: '' };

    // Produkte für "Alle Altersstufen" / "Alle Rassen" passen zu jeder Auswahl.
    var WILDCARD = { age: 'alle-altersstufen', size: 'alle-rassen', form: '', flavor: '' };

    function matches(card) {
      return ['age', 'size', 'form', 'flavor'].every(function (key) {
        var wanted = state[key];
        if (!wanted) return true;
        var has = tokens(card.dataset[key]);
        if (has.indexOf(wanted) !== -1) return true;
        return WILDCARD[key] ? has.indexOf(WILDCARD[key]) !== -1 : false;
      });
    }

    function apply(userAction) {
      var hits = cards.filter(matches);

      cards.forEach(function (card) { card.hidden = true; });
      hits.slice(0, visible).forEach(function (card) { card.hidden = false; });

      if (countEl) {
        var active = state.age || state.size || state.form || state.flavor;
        if (!active) countEl.textContent = 'Unsere meistgekauften Sorten';
        else if (hits.length === 1) countEl.textContent = '1 passendes Produkt';
        else countEl.textContent = hits.length + ' passende Produkte';
      }

      if (emptyEl)  emptyEl.hidden = hits.length !== 0;
      if (gridEl)   gridEl.hidden  = hits.length === 0;
      if (moreWrap) moreWrap.hidden = hits.length <= visible;
      if (moreBtn) {
        var rest = Math.max(0, Math.min(STEP, hits.length - visible));
        moreBtn.textContent = 'Weitere ' + rest + ' anzeigen';
      }
      if (resetEl) resetEl.hidden = !(state.age || state.size || state.form || state.flavor);

      if (userAction) {
        track('wd_finder_filter', {
          wd_age: state.age || null,
          wd_size: state.size || null,
          wd_form: state.form || null,
          wd_flavor: state.flavor || null,
          wd_results: hits.length
        });
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var group = chip.dataset.wdGroup;
        var value = chip.dataset.wdValue;
        if (!group) return;

        var isOn = chip.getAttribute('aria-pressed') === 'true';
        root.querySelectorAll('[data-wd-chip][data-wd-group="' + group + '"]').forEach(function (sib) {
          sib.setAttribute('aria-pressed', 'false');
        });

        if (isOn) {
          state[group] = '';
        } else {
          state[group] = value;
          chip.setAttribute('aria-pressed', 'true');
        }

        visible = STEP;
        apply(true);
      });
    });

    if (resetEl) {
      resetEl.addEventListener('click', function () {
        state = { age: '', size: '', form: '', flavor: '' };
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        visible = STEP;
        apply(false);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        visible += STEP;
        apply(false);
        track('wd_finder_more', { wd_visible: visible });
      });
    }

    apply(false);
  }

  /* --- Größenauswahl in der Produktkarte ---------------------------------- */

  function initSizePicker() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-wd-size]');
      if (!btn) return;

      var card = btn.closest('.wd-pc');
      if (!card) return;

      card.querySelectorAll('[data-wd-size]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', 'true');

      var input = card.querySelector('[data-wd-variant-input]');
      if (input) input.value = btn.dataset.wdVariant;

      // Preis auf die gewählte Größe umstellen, das "ab" fällt dabei weg.
      var out = card.querySelector('[data-wd-price-out]');
      if (out && btn.dataset.wdPrice) out.textContent = btn.dataset.wdPrice;
      var pre = card.querySelector('[data-wd-price-pre]');
      if (pre) pre.remove();
    });
  }

  /* --- In den Warenkorb --------------------------------------------------- */

  function refreshCartBadges() {
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document
          .querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span:first-child, #CartCount')
          .forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function () { /* still */ });
  }

  function initAddToCart() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-wd-add]');
      if (!form) return;

      event.preventDefault();

      var button  = form.querySelector('button[type="submit"]');
      var label   = form.querySelector('[data-wd-add-label]');
      var note    = form.querySelector('[data-wd-add-note]');
      var idField = form.querySelector('[name="id"]');
      var variantId = idField ? idField.value : null;
      if (!variantId) return;

      if (button) button.disabled = true;
      if (label)  label.textContent = 'Wird hinzugefügt …';

      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Leider nicht möglich.');
            return data;
          });
        })
        .then(function (data) {
          var item = (data.items && data.items[0]) || data;
          track('add_to_cart', {
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
            value: item && item.final_price ? item.final_price / 100 : undefined,
            items: item ? [{ item_id: item.product_id, item_name: item.product_title, item_variant: item.variant_title, quantity: 1 }] : undefined,
            wd_source: 'white-dogs-lp'
          });

          if (form.dataset.afterAdd === 'stay') {
            if (label) label.textContent = 'Nochmal hinzufügen';
            if (note) { note.hidden = false; note.textContent = 'Im Warenkorb ✓'; }
            if (button) button.disabled = false;
            refreshCartBadges();
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function (error) {
          // Trifft auch die Mengenbegrenzung der Proben — Shopify liefert dann
          // eine sprechende Meldung, die wir direkt unter dem Button zeigen.
          if (label) label.textContent = 'In den Warenkorb';
          if (note) { note.hidden = false; note.textContent = error.message || 'Leider nicht möglich.'; }
          if (button) button.disabled = false;
        });
    });
  }

  /* --- Sticky CTA --------------------------------------------------------- */

  function initSticky() {
    var bar = document.querySelector('[data-wd-sticky]');
    if (!bar) return;

    var anchor = document.querySelector('[data-wd-sticky-after]') || document.querySelector('[data-wd-finder]');

    // Scroll-Listener statt IntersectionObserver: der Anker kann höher als der
    // Viewport sein, dann feuert ein Observer beim Weiterscrollen nicht mehr.
    var ticking = false;

    function update() {
      ticking = false;
      var show = anchor
        ? anchor.getBoundingClientRect().bottom < 0
        : window.pageYOffset > window.innerHeight;
      bar.classList.toggle('is-visible', show);

      if (window.matchMedia('(min-width: 900px)').matches) {
        document.body.style.paddingBottom = '';
      } else {
        document.body.style.paddingBottom = show ? bar.offsetHeight + 'px' : '';
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* --- Sanftes Scrollen zu Ankern ----------------------------------------- */

  function initAnchors() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-wd-scroll]');
      if (!link) return;
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      track('wd_cta_click', { wd_target: link.getAttribute('href'), wd_label: link.textContent.trim() });
    });
  }

  function boot() {
    document.querySelectorAll('[data-wd-finder]').forEach(initFinder);
    initSizePicker();
    initAddToCart();
    initSticky();
    initAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var finder = event.target.querySelector('[data-wd-finder]');
    if (finder) initFinder(finder);
    initSticky();
  });
})();
